<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <b-card>
      <b-tabs pills align="center">
        <validation-observer ref="headerForm">
          <b-tab active :title="locals('leadcust.info')">
            <b-card-text class="card-title">
              {{ $t("leadcust.leadcust") }}
            </b-card-text>
            <b-card>
              <b-row class="pt-1">
                <b-col md="6">
                  <b-form-group
                    label-for="i-customer-name"
                    label="ชื่อบริษัท (Company Name)"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ชื่อบริษัท (Company Name)"
                      rules="required"
                    >
                      <b-form-input
                        id="i-customer-name"
                        v-model="listData.strCustomerName"
                        :disabled="isEdit || ifView"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="ประเภทนิติบุคคล (Title)"
                    label-for="i-type"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ประเภทนิติบุคคล (Title)"
                      rules="required"
                    >
                      <v-select
                        input-id="i-type"
                        v-model="listData.intTypeId"
                        :reduce="(val) => val.intDsId"
                        :placeholder="locals('select.placeholder')"
                        @input="onChangeVal(listData.intTypeId, 'type')"
                        label="strDsDesc"
                        :options="TypeOptions"
                        :disabled="ifView"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="เลขผู้เสียภาษี (Tax Id)"
                    label-for="i-tax-id"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="เลขผู้เสียภาษี (Tax Id)"
                      rules="required"
                    >
                      <b-form-input
                        id="i-customer-name"
                        v-model="listData.strTaxId"
                        placeholder="Tax Id"
                        :disabled="ifView"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="ทุนจดทะเบียน (Register Group)"
                    label-for="i-register-grp"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ทุนจดทะเบียน (Register Group)"
                      rules="required"
                    >
                      <cleave
                        v-model="listData.intRegCapital"
                        class="form-control"
                        :raw="false"
                        :options="options.number"
                        placeholder="Number"
                        :disabled="ifView"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <b-row class="pt-1">
                <b-col md="12">
                  <b-form-group
                    label="บริการที่น่าสนใจ (Service Interest) เลือกอย่างน้อย 1 รายการ "
                    class="title-freight-require"
                  >
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pt-1">
                  <b-form-checkbox
                    class="custom-control-danger"
                    v-model="listData.freight_flag"
                    :disabled="ifView"
                  >
                    บริการ Freight
                  </b-form-checkbox>
                </b-col>
                <b-col md="9">
                  <b-form-group label-for="i-service-freight-remark">
                    <b-form-input
                      id="i-service-freight-remark"
                      v-model="listData.strFreightRemark"
                      class="title-freight"
                      :disabled="!listData.freight_flag || ifView"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pt-1">
                  <b-form-checkbox
                    class="custom-control-danger"
                    v-model="listData.broker_flag"
                    :disabled="ifView"
                  >
                    บริการ Custom Broker & Domestic transportation
                  </b-form-checkbox>
                </b-col>
                <b-col md="9">
                  <b-form-group label-for="i-service-custom-remark">
                    <b-form-input
                      id="i-service-custom-remark"
                      v-model="listData.strBrokerRemark"
                      :disabled="!listData.broker_flag || ifView"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pt-1">
                  <b-form-checkbox
                    class="custom-control-danger"
                    v-model="listData.ra_flag"
                    :disabled="ifView"
                  >
                    บริการ RA
                  </b-form-checkbox>
                </b-col>
                <b-col md="9">
                  <b-form-group label-for="i-service-ra-remark">
                    <b-form-input
                      id="i-service-ra-remark"
                      v-model="listData.strRARemark"
                      :disabled="!listData.ra_flag || ifView"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pt-1">
                  <b-form-checkbox
                    class="custom-control-danger"
                    v-model="listData.legal_flag"
                    :disabled="ifView"
                  >
                    บริการ งานกฎหมาย Legal
                  </b-form-checkbox>
                </b-col>
                <b-col md="9">
                  <b-form-group label-for="i-service-legal-remark">
                    <b-form-input
                      id="i-service-legal-remark"
                      v-model="listData.strLegalRemark"
                      :disabled="!listData.legal_flag || ifView"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="pt-1">
                <b-col md="6">
                  <b-form-group
                    label="ประเภทอุตสาหกรรมหลัก"
                    label-for="i-main"
                    class="title-freight-require"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="ประเภทอุตสาหกรรมหลัก"
                      rules="required"
                    >
                      <v-select
                        input-id="i-main"
                        :clearable="true"
                        v-model="listData.intIndusMainId"
                        :placeholder="locals('select.placeholder')"
                        label="strDsDesc"
                        :reduce="(val) => val.intDsId"
                        @input="onChangeVal(listData.intIndusMainId, 'mainInd')"
                        :options="MainOptions"
                        :disabled="ifView"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="ประเภทอุตสาหกรรมรอง"
                    label-for="i-sub"
                    class="title-freight"
                  >
                    <v-select
                      input-id="i-sub"
                      :clearable="true"
                      v-model="listData.intIndusSubId"
                      :placeholder="locals('select.placeholder')"
                      label="strDsDesc"
                      :reduce="(val) => val.intDsId"
                      @input="onChangeVal(listData.intIndusSubId, 'subInd')"
                      :options="MainOptions"
                      :disabled="ifView"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="แหล่งที่มา"
                    label-for="i-ref"
                    class="title-freight"
                  >
                    <v-select
                      input-id="i-ref"
                      v-model="listData.intSourceId"
                      :placeholder="locals('select.placeholder')"
                      label="strDsDesc"
                      :reduce="(val) => val.intDsId"
                      @input="onChangeVal(listData.intSourceId, 'source')"
                      :options="TestOptions"
                      :disabled="ifView"
                    />
                  </b-form-group>
                </b-col>
              </b-row> -->
              <b-row>
                <b-col md="12" class="pt-1">
                  <b-form-group
                    label-for="i-attach-file"
                    :label="locals('inquiry.attach_file_msds')"
                    class="title-freight"
                  >
                    <b-form-file
                      accept=".pdf,.jpeg,.jpg,.png"
                      :placeholder="locals('select.attach')"
                      multiple
                      v-model="listData.strFile"
                      @input="checkAndCompressListService('Cust', 1)"
                      :disabled="ifView"
                    />
                  </b-form-group>
                  <span v-for="(obj, index) in listData.strFile">
                    <span
                      v-if="obj.strFilePath != '' && obj.strFilePath != null"
                    >
                      <a href="#" @click="onView(obj)">
                        <feather-icon
                          icon="DownloadIcon"
                          class="mr-50"
                          stroke="blue"
                          fill="blue"
                        />
                        {{ obj.name }}
                      </a>
                    </span>
                  </span>
                </b-col>
                <b-col md="12">
                  <label for="textarea-default" class="title-freight">{{
                    $t("inquiry.remark")
                  }}</label>
                  <b-form-textarea
                    id="textarea-default"
                    placeholder="Textarea"
                    rows="3"
                    v-model="listData.strRemark"
                    :disabled="ifView"
                  />
                </b-col>
              </b-row>
              <div>
                <b-row class="pt-2">
                  <b-col md="12">
                    <b-form-group
                      :label="locals('leadcust.contactname')"
                      class="title-freight-require"
                    >
                      <!-- <br /> -->
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="pt-2">
                  <b-col md="12">
                    <b-table
                      :fields="columns"
                      :items="listDetails"
                      striped
                      responsive
                    >
                      <template #head(strContactName)="">
                        <div class="text-nowrap">
                          {{ $t("leadcust.contactname") }}
                        </div>
                      </template>
                      <template #head(strNickName)="">
                        <div class="text-nowrap">
                          {{ $t("leadcust.nickname") }}
                        </div>
                      </template>
                      <template #head(strTelNo)="">
                        <div class="text-nowrap">
                          {{ $t("leadcust.telno") }}
                        </div>
                      </template>
                      <template #head(strEmail)="">
                        <div class="text-nowrap">
                          {{ $t("leadcust.email") }}
                        </div>
                      </template>
                      <template #head(strDepartment)="">
                        <div class="text-nowrap">
                          {{ $t("leadcust.department") }}
                        </div>
                      </template>
                      <template #head(strPosition)="">
                        <div class="text-nowrap">
                          {{ $t("leadcust.position") }}
                        </div>
                      </template>
                      <template #head(strRemark)="">
                        <div class="text-nowrap">
                          {{ $t("inquiry.remark") }}
                        </div>
                      </template>
                      <template #cell(action)="data">
                        <div class="text-center">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            :disabled="ifView"
                            @click="removeSubFreight(data.index)"
                          >
                            <font-awesome-icon icon="fa-solid fa-trash" />
                          </b-button>
                        </div>
                      </template>
                      <template
                        v-slot:cell(strTelNo)="{ item, field: { key } }"
                      >
                        <b-form-input
                          id="i-telno"
                          v-model="item[key]"
                          type="number"
                          style="width: 160px"
                          @input="validateTelNo(index)"
                        />
                      </template>
                      <template v-slot:cell()="{ item, field: { key } }">
                        <b-form-input
                          v-model="item[key]"
                          style="width: 160px"
                          :disabled="ifView"
                        />
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <div class="d-flex justify-content-end">
                      <b-button
                        v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                        variant="outline-info"
                        pill
                        @click="onAddSubFreight"
                        :hidden="ifView"
                      >
                        <feather-icon icon="PlusIcon" class="mr-50" />
                        <span class="align-middle">{{
                          $t("button.add_row")
                        }}</span>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <hr />
                <!-- <b-row class="pt-2">
                  <b-col md="12">
                    <b-form-group label="Lead Stage & Tier">
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Lead Stage"
                      label-for="i-lead-stage"
                      class="title-freight-require"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Lead Stage"
                        rules="required"
                      >
                        <v-select
                          input-id="i-lead-stage"
                          v-model="listData.intLeadId"
                          :placeholder="locals('select.placeholder')"
                          label="strDsDesc"
                          :reduce="(val) => val.intDsId"
                          :options="leadstage"
                          @input="onChangeVal(listData.intLeadId, 'leadstage')"
                          :disabled="ifView"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label-for="i-tier"
                      label="Customer Tier"
                      class="title-freight"
                    >
                      <b-form-input
                        id="i-tier"
                        v-model="listData.strCustomerTier"
                        disabled
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Estimate ยอดซื้อต่อปี"
                      label-for="i-Estimate"
                      class="title-freight"
                    >
                      <cleave
                        v-model="listData.intEstCost"
                        class="form-control"
                        :raw="false"
                        :options="options.number"
                        placeholder="Number"
                        :disabled="ifView"
                      />
                    </b-form-group>
                  </b-col>
                </b-row> -->
              </div>
            </b-card>
          </b-tab>
        </validation-observer>
        <b-tab :title="locals('leadcust.addr')">
          <b-card-text class="card-title">
            {{ $t("leadcust.addr") }}
          </b-card-text>
          <b-col md="12">
            <div class="d-flex justify-content-end">
              <b-button
                v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                variant="outline-info"
                pill
                @click="onAddAddr"
                :hidden="ifView"
              >
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">{{ $t("button.add_row") }}</span>
              </b-button>
            </div>
          </b-col>
          <div v-for="(addr, index) in listAddr" :key="index">
            <b-row class="pt-1">
              <b-col md="12">
                <span name="other" class="title-freight">
                  รายการที่ {{ index + 1 }}
                </span>
              </b-col>
            </b-row>
            <b-row class="pt-1">
              <b-col md="10">
                <b-form-group
                  label-for="i-main-addr"
                  :label="locals('leadcust.addrname')"
                  class="title-freight-require"
                >
                  <b-form-input
                    id="i-main-addr"
                    v-model="addr.strAddrName"
                    :disabled="ifView"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <div class="d-flex justify-content-end">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                    @click="removeAddr(index)"
                    :disabled="ifView"
                  >
                    <font-awesome-icon icon="fa-solid fa-trash" />
                  </b-button>
                </div>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="i-addr"
                  :label="locals('leadcust.addr')"
                  class="title-freight-require"
                >
                  <b-form-input
                    id="i-addr"
                    v-model="addr.strAddrDesc"
                    :disabled="ifView"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="locals('inquiry.city')"
                  label-for="i-province"
                  class="title-freight-require"
                >
                  <v-select
                    v-model="addr.intProvinceId"
                    :options="provinceOptions"
                    :placeholder="locals('select.placeholder')"
                    :reduce="(val) => val.intDsId"
                    :clearable="true"
                    @input="onChangeAddr(index, addr.intProvinceId, 'province')"
                    label="strDsDesc"
                    input-id="i-province"
                    :disabled="ifView"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="locals('inquiry.district')"
                  label-for="i-district"
                  class="title-freight-require"
                >
                  <v-select
                    v-model="addr.intDistrictId"
                    :options="
                      districtOptions.filter(
                        (b) => b.intRefId == addr.intProvinceId
                      )
                    "
                    :placeholder="locals('select.placeholder')"
                    :reduce="(val) => val.intDsId"
                    @input="onChangeAddr(index, addr.intDistrictId, 'district')"
                    label="strDsDesc"
                    :clearable="true"
                    input-id="i-district"
                    :disabled="ifView"
                  >
                    <template #option="{ strRefDesc, strDsDesc }">
                      <h6 style="margin: 0">{{ strDsDesc }}</h6>
                      <em>{{ strRefDesc }}</em>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="locals('inquiry.sub_district')"
                  label-for="i-sub-district"
                  class="title-freight-require"
                >
                  <v-select
                    v-model="addr.intSubDistrictId"
                    :options="
                      subdistrictOptions.filter(
                        (b) => b.intRefId == addr.intDistrictId
                      )
                    "
                    :placeholder="locals('select.placeholder')"
                    :reduce="(val) => val.intDsId"
                    @input="
                      onChangeAddr(index, addr.intSubDistrictId, 'subdistrict')
                    "
                    label="strDsDesc"
                    :clearable="true"
                    input-id="i-sub-district"
                    :disabled="ifView"
                  >
                    <template #option="{ strRefDesc, strDsDesc }">
                      <h6 style="margin: 0">{{ strDsDesc }}</h6>
                      <em>{{ strRefDesc }}</em>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="locals('inquiry.post_code')"
                  label-for="i-postcode"
                  class="title-freight-require"
                >
                  <v-select
                    v-model="addr.intPostcodeId"
                    :options="
                      postcodeOptions.filter(
                        (b) => b.intMainRefId == addr.intProvinceId
                      )
                    "
                    :placeholder="locals('select.placeholder')"
                    :reduce="(val) => val.intDsId"
                    @input="onChangeAddr(index, addr.intPostcodeId, 'postcode')"
                    label="strDsDesc"
                    :clearable="true"
                    input-id="i-postcode"
                    :disabled="ifView"
                  >
                    <template #option="{ strRefDesc, strDsDesc }">
                      <h6 style="margin: 0">{{ strDsDesc }}</h6>
                      <em>{{ strRefDesc }}</em>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group
                  label-for="i-email"
                  :label="locals('leadcust.email')"
                  class="title-freight"
                >
                  <b-form-input
                    id="i-email"
                    v-model="addr.strEmail"
                    :class="{ 'is-invalid': !isEmailValid }"
                    @input="validateEmail(index)"
                    :disabled="ifView"
                  />
                  <b-form-invalid-feedback v-if="!isEmailValid">
                    Please enter a valid email address.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label-for="i-attach-file"
                  :label="locals('inquiry.attached_file')"
                  class="title-freight"
                >
                  <b-form-file
                    multiple
                    accept=".pdf,.jpeg,.jpg,.png"
                    :placeholder="locals('select.attach')"
                    v-model="addr.strFile"
                    :disabled="ifView"
                    @input="checkAndCompressListService('Addr', 1)"
                  />
                </b-form-group>
                <span v-for="(obj, index) in addr.strFile">
                  <span v-if="obj.strFilePath != '' && obj.strFilePath != null">
                    <a href="#" @click="onView(obj)">
                      <feather-icon
                        icon="DownloadIcon"
                        class="mr-50"
                        stroke="blue"
                        fill="blue"
                      />
                      {{ obj.name }}
                    </a>
                  </span>
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group
                  label-for="i-link"
                  label="Link Google Map"
                  class="title-freight"
                >
                  <b-form-input
                    id="i-link"
                    v-model="addr.strLink"
                    :disabled="ifView"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <label for="i-note" class="title-freight">{{
                  locals("leadcust.location_mark")
                }}</label>
                <b-form-textarea
                  id="i-location-mark"
                  placeholder=""
                  rows="2"
                  v-model="addr.strLocationMark"
                  maxlength="500"
                  :disabled="ifView"
                  @keydown.enter.prevent="showMessage2"
                />
                <p v-if="enterPressed2" class="text-danger pt-1">
                  {{ locals("leadcust.error_msg1") }}
                </p>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="i-contact"
                  :label="locals('leadcust.maincontactname')"
                  class="title-freight-require pt-1"
                >
                  <b-form-input id="i-contact" v-model="addr.strContactName" />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="i-telno"
                  :label="locals('leadcust.maintelno')"
                  class="title-freight-require pt-1"
                >
                  <b-form-input
                    id="i-telno"
                    v-model="addr.strTelNo"
                    type="number"
                    :class="{ 'is-invalid': !isTelNoValid }"
                    @input="validateTelNo(index)"
                  />
                  <b-form-invalid-feedback v-if="!isTelNoValid">
                    ❌ Please enter a valid telephone number. ❌
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <hr style="height: 2px; border: none; background-color: #00bcd4" />
            <hr style="height: 2px; border: none; background-color: #3f51b5" />
          </div>
        </b-tab>
      </b-tabs>
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1 btn-fixed-width"
            pill
            @click="onSubmit('Submit')"
            :hidden="ifView"
          >
            <font-awesome-icon icon="fa-solid fa-check" />
            {{ $t("button.submit") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="save"
            variant="outline-success"
            class="mr-1 btn-fixed-width"
            pill
            @click="onSubmit('Draft')"
            :hidden="ifView"
          >
            <font-awesome-icon icon="fa-solid fa-check" />
            {{ $t("button.draft") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="onBack"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="listData.intCustomerId != -1">
      <span name="history"> {{ $t("leadcust.history") }} </span>
      <!-- History Table  -->
      <b-row class="pt-2">
        <b-col md="12">
          <vue-good-table
            :columns="historycolumns"
            :rows="listHistory"
            styleClass="vgt-table condensed"
          >
            <template slot="table-column" slot-scope="props">
              <span
                v-if="props.column.label === 'น้ำหนัก (kg)'"
                class="text-nowrap"
              >
                {{ $t("inquiry.weight") }}
              </span>
              <span
                v-else-if="props.column.label === 'ยาว (cm)'"
                class="text-nowrap"
              >
                {{ $t("inquiry.length") }}
              </span>
              <span v-else>
                {{ props.column.label }}
              </span>
            </template>

            <template slot="table-row" slot-scope="props">
              <!-- Column: Action -->
              <span v-if="props.column.field === '#'">
                {{ props.index + 1 }}
              </span>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseCheck from "@core/components/app-collapse/AppCollapseCheck.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import flatPickr from "vue-flatpickr-component";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import base64toblob from "base64toblob";

import {
  BTable,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BFormCheckbox,
  BFormTextarea,
  BFormSelect,
  BPagination,
  BInputGroupPrepend,
  BFormFile,
  BTabs,
  BTab,
  BCardText,
  BModal,
  VBModal,
  BSpinner,
  BOverlay,
  VBTooltip,
} from "bootstrap-vue";

import Service from "@/@API/cDropdown";
import CustService from "@/@API/cCustomer";

export default {
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BTable,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    AppCollapse,
    AppCollapseItem,
    AppCollapseCheck,
    BFormRadio,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BFormCheckbox,
    BFormSelect,
    vSelect,
    flatPickr,
    BFormTextarea,
    VueGoodTable,
    BPagination,
    BInputGroupPrepend,
    BButton,
    BFormFile,
    Cleave,
    BTabs,
    BTab,
    BCardText,
    BModal,
    VBModal,
    BSpinner,
    BOverlay,
    VBTooltip,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      strInputStatus: "",
      strStatusShow: "",
      showCustomerName: "",
      showStatus: "",
      showBy: "",
      busy: true,
      processing: false,
      isLoading: true,
      enterPressed: false,
      enterPressed2: false,
      isEmailValid: true,
      isTelNoValid: true,
      isSaving: false,
      isEdit: false,
      ifView: false,
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          numeralDecimalScale: 3,
        },
      },
      MainOptions: [
        {
          intDsId: 1,
          strDsDesc: "ผลิต",
        },
        {
          intDsId: 2,
          strDsDesc: "ขนส่ง",
        },
        {
          intDsId: 3,
          strDsDesc: "บริการ",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      TypeOptions: [
        {
          intDsId: 1,
          strDsDesc: "นิติบุคคล",
        },
        {
          intDsId: 2,
          strDsDesc: "อื่น ๆ",
        },
      ],
      leadstage: [
        { intDsId: 1, strDsDesc: "New" },
        { intDsId: 2, strDsDesc: "Work" },
        { intDsId: 3, strDsDesc: "Unqualified" },
        { intDsId: 4, strDsDesc: "Convert" },
      ],
      UserOptions: [
        {
          intDsId: 99,
          strDsDesc: "-",
        },
      ],
      ori_country: [],
      CountryOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_province: [],
      provinceOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_district: [],
      districtOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_subdistrict: [],
      subdistrictOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      ori_postcode: [],
      postcodeOptions: [
        {
          strDsDesc: "Loading...",
          intDsId: -1,
          intRefId: -1,
        },
      ],
      pageLength: 3,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          key: "action",
          width: "100px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อผู้ติดต่อ",
          key: "strContactName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อเล่น",
          key: "strNickName",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "เบอร์โทร",
          key: "strTelNo",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "อีเมลล์",
          key: "strEmail",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "หน่วยงาน",
          key: "strDepartment",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ตำแหน่ง",
          key: "strPosition",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      searchTerm: "",
      ownercolumns: [
        {
          label: "หน้าที่",
          key: "strRole",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้ดูแลหลัก",
          key: "intUserId",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้ดูแลรอง",
          key: "intSubUserId",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      ori_ownerrows: [
        {
          intItemId: 1,
          strRole: "Lead Owner *",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 2,
          strRole: "Sale Person (Freight & Custom Broker) *",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 3,
          strRole: "Sale Person (Warehouse & Transport)",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 4,
          strRole: "Key Account Manager (2)",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 5,
          strRole: "Pricing & Key Account (1)",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 6,
          strRole: "Freight Quotation",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 7,
          strRole: "Shipping Quotation",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 8,
          strRole: "RA Quotation",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 9,
          strRole: "Legal Quotation",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 10,
          strRole: "CS Freight Import",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 11,
          strRole: "CS Freight Export",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 12,
          strRole: "CS Shipping Import",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 13,
          strRole: "CS Shipping Export",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 14,
          strRole: "CS Shipping Manager",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 15,
          strRole: "Freight Manager",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 16,
          strRole: "RA Manager",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 17,
          strRole: "Key Account #2",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 18,
          strRole: "Key Account #3",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
      ],
      ownerrows: [
        {
          intItemId: 1,
          strRole: "Lead Owner *",
          intUserId: 1,
          strUsername: "คุณดิว",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 2,
          strRole: "Sale Person (Freight & Custom Broker) *",
          intUserId: 1,
          strUsername: "คุณดิว",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 3,
          strRole: "Sale Person (Warehouse & Transport)",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 4,
          strRole: "Key Account Manager (2)",
          intUserId: 2,
          strUsername: "คุณกุ๊ก",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 5,
          strRole: "Pricing & Key Account (1)",
          intUserId: 4,
          strUsername: "คุณโปเต้",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 6,
          strRole: "Freight Quotation",
          intUserId: 4,
          strUsername: "คุณโปเต้",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 7,
          strRole: "Shipping Quotation",
          intUserId: 5,
          strUsername: "คุณเจน",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 8,
          strRole: "RA Quotation",
          intUserId: 5,
          strUsername: "คุณเจน",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 9,
          strRole: "Legal Quotation",
          intUserId: 99,
          strUsername: "-",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 10,
          strRole: "CS Freight Import",
          intUserId: 6,
          strUsername: "คุณจุ๊บแจง",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 11,
          strRole: "CS Freight Export",
          intUserId: 7,
          strUsername: "คุณนภ",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 12,
          strRole: "CS Shipping Import",
          intUserId: 8,
          strUsername: "คุณดา",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 13,
          strRole: "CS Shipping Export",
          intUserId: 8,
          strUsername: "คุณดา",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 14,
          strRole: "CS Shipping Manager",
          intUserId: 9,
          strUsername: "คุณน้อง",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 15,
          strRole: "Freight Manager",
          intUserId: 2,
          strUsername: "คุณกุ๊ก",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 16,
          strRole: "RA Manager",
          intUserId: 10,
          strUsername: "คุณปุ๋ม",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 17,
          strRole: "Key Account #2",
          intUserId: 2,
          strUsername: "คุณกุ๊ก",
          intSubUserId: "",
          strSubUsername: "",
        },
        {
          intItemId: 18,
          strRole: "Key Account #3",
          intUserId: 1,
          strUsername: "คุณดิว",
          intSubUserId: "",
          strSubUsername: "",
        },
      ],
      searchOwner: "",
      listData: {
        intCustomerId: -1,
        strCustomerName: "",
        intTypeId: 2,
        strType: "",
        strTaxId: "",
        intRegCapital: "",
        freight_flag: false,
        broker_flag: false,
        ra_flag: false,
        legal_flag: false,
        strFreightFlag: "N",
        strFreightRemark: "",
        strBrokerFlag: "N",
        strBrokerRemark: "",
        strRAFlag: "N",
        strRARemark: "",
        strLegalFlag: "N",
        strLegalRemark: "",
        intIndusMainId: "",
        strIndusMainDesc: "",
        intIndusSubId: "",
        strIndusSubDesc: "",
        intSourceId: "",
        strSource: "",
        strRemark: "",
        intLeadId: "",
        strLead: "",
        intCustomerTierId: "",
        strCustomerTier: "",
        intEstCost: "",
        strFile: null,
      },
      listDetails: [],
      listAddr: [],
      historycolumns: [
        {
          label: "#",
          field: "#",
          width: "80px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Action",
          field: "strLogStatus",
          width: "220px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้อัพเดท",
          field: "strUpdatedBy",
          width: "160px",
        },
        {
          label: "วันที่อัพเดท",
          field: "datUpdatedDate",
          width: "160px",
        },
        {
          label: "Remark",
          field: "strRemark",
          width: "200px",
        },
      ],
      listHistory: [
        {
          strLogStatus: "TEST",
          strUpdatedBy: "admin@$$$.com",
          datUpdatedDate: "dd/MM/yyyy HH:mm",
          strRemark: "",
        },
        {
          strLogStatus: "TEST",
          strUpdatedBy: "admin@$$$.com",
          datUpdatedDate: "dd/MM/yyyy HH:mm",
          strRemark: "",
        },
      ],
    };
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {},
  mounted() {
    let Id = localStorage.getItem("customer-id");
    let lang = localStorage.getItem("language");

    //serviceOptions
    Service.getAllDropdownForCustomerForm({})
      .then((response) => {
        console.log(response.data);
        let etcobj = {
          intDsId: 9999,
          strDsName: "ETC",
          strDsDesc: "ETC",
          intRefId: -1,
          strRefDesc: "ETC",
        };

        //  ori_province provinceOptions ori_district districtOptions
        //  ori_subdistrict subdistrictOptions  ori_postcode postcodeOptions
        this.ori_province = [];
        response.data.lstProvince.forEach((e) => {
          this.ori_province.push(e);
        });
        let newlist15 = [];
        this.provinceOptions = [];
        newlist15 = this.ori_province.filter((a) => a.strLanguage == lang);
        newlist15.forEach((f) => {
          this.provinceOptions.push(f);
        });

        this.ori_district = [];
        response.data.lstDistrict.forEach((e) => {
          this.ori_district.push(e);
        });
        let newlist16 = [];
        this.districtOptions = [];
        newlist16 = this.ori_district.filter((a) => a.strLanguage == lang);
        newlist16.forEach((f) => {
          this.districtOptions.push(f);
        });
        this.districtOptions.push(etcobj);

        this.ori_subdistrict = [];
        response.data.lstSubDistrict.forEach((e) => {
          this.ori_subdistrict.push(e);
        });
        let newlist17 = [];
        this.subdistrictOptions = [];
        newlist17 = this.ori_subdistrict.filter((a) => a.strLanguage == lang);
        newlist17.forEach((f) => {
          this.subdistrictOptions.push(f);
        });
        this.subdistrictOptions.push(etcobj);

        this.ori_postcode = [];
        response.data.lstPostcode.forEach((e) => {
          this.ori_postcode.push(e);
        });
        let newlist18 = [];
        this.postcodeOptions = [];
        newlist18 = this.ori_postcode;
        newlist18.forEach((f) => {
          this.postcodeOptions.push(f);
        });
        this.postcodeOptions.push(etcobj);

        this.busy = false;
        //this.isLoading = false;
      })
      .catch((error) => {
        this.busy = false;
        //this.isLoading = false;
      });

    if (Id == -1) {
      var new_date = moment().add(1, "days");
      new_date = new_date.format("DD/MM/YYYY");

      this.isLoading = false;
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "สร้างเอกสาร",
            icon: "PlusIcon",
            variant: "success",
            text: "สร้างเอกสารใหม่",
          },
        },
        {
          position: "top-center",
        }
      );
    } else {
      CustService.getFormCustomer({ intCustomerId: Id })
        .then((response) => {
          this.listData = response.data.headerGrid;
          this.isEdit = true;
          this.showCustomerName = " (" + this.listData.strCustomerName + ") ";
          this.showStatus = this.listData.strStatus;
          this.showBy = this.listData.strCreatedBy;
          console.log("response.data", response.data);

          if (this.listData.strFreightFlag == "Y") {
            this.listData.freight_flag = true;
          }
          if (this.listData.strBrokerFlag == "Y") {
            this.listData.broker_flag = true;
          }
          if (this.listData.strRAFlag == "Y") {
            this.listData.ra_flag = true;
          }
          if (this.listData.strLegalFlag == "Y") {
            this.listData.legal_flag = true;
          }
          if (this.listData.intIndusMainId <= 0) {
            this.listData.intIndusMainId = "";
          }
          if (this.listData.intIndusSubId <= 0) {
            this.listData.intIndusSubId = "";
          }
          if (this.listData.intSourceId <= 0) {
            this.listData.intSourceId = "";
          }
          if (this.listData.intLeadId <= 0) {
            this.listData.intLeadId = "";
          }
          if (this.listData.intCustomerTierId <= 0) {
            this.listData.intCustomerTierId = "";
          }

          //Log
          if (response.data.logList != null) {
            this.listHistory = response.data.logList;
            if (this.listHistory.length > 0) {
              this.listHistory.forEach((dat, index) => {
                const updatedated = moment(dat.datUpdatedDate).format(
                  "DD/MM/YYYY HH:mm"
                );
                dat.datUpdatedDate = updatedated;
              });
            }
          }
          // header file
          if (response.data.headerFile != null) {
            let filedata = response.data.headerFile;
            if (filedata.length > 0) {
              this.listData.strFile = [];
              filedata.forEach((fileobj, subindex) => {
                var newf = new File([""], fileobj.strFreightFileName, {
                  type: fileobj.strFileType,
                });
                newf.intDetailId = fileobj.intDetailId;
                newf.strFileName = fileobj.strFileName;
                newf.strFilePath = fileobj.strFilePath.replaceAll("\\", "/");
                this.listData.strFile.push(newf);
              });
            }
          }

          if (response.data.contactList != null) {
            this.listDetails = response.data.contactList;
          }

          if (response.data.accountList != null) {
            response.data.accountList.forEach((dat, index) => {
              if (dat.intUserId <= 0) {
                dat.intUserId = "";
              }
              if (dat.intSubUserId <= 0) {
                dat.intSubUserId = "";
              }
            });
            this.ownerrows = response.data.accountList;
          }

          if (response.data.addressList != null) {
            response.data.addressList.forEach((dat, index) => {
              if (dat.intProvinceId <= 0) {
                dat.intProvinceId = "";
              }
              if (dat.intDistrictId <= 0) {
                dat.intDistrictId = "";
              }
              if (dat.intSubDistrictId <= 0) {
                dat.intSubDistrictId = "";
              }
              if (dat.intPostcodeId <= 0) {
                dat.intPostcodeId = "";
              }

              if (response.data.addrFile != null) {
                let filedata = response.data.addrFile.filter(
                  (fl) => fl.intAddrId == dat.intDetailId
                );
                if (filedata.length > 0) {
                  dat.strFile = [];
                  filedata.forEach((fileobj, subindex) => {
                    var newf = new File([""], fileobj.strFreightFileName, {
                      type: fileobj.strFileType,
                    });
                    newf.intDetailId = fileobj.intDetailId;
                    newf.strFileName = fileobj.strFileName;
                    newf.strFilePath = fileobj.strFilePath.replaceAll(
                      "\\",
                      "/"
                    );
                    dat.strFile.push(newf);
                  });
                }
              }
            });
            this.listAddr = response.data.addressList;
          }

          this.isLoading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "แก้ไขบริษัท",
                icon: "EditIcon",
                variant: "warning",
                text: "แก้ไขบริษัท : " + this.listData.strCustomerName,
              },
            },
            {
              position: "top-center",
            }
          );
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    }
  },
  methods: {
    validateTelNo(i) {
      // Example pattern: allows digits, spaces, hyphens, and parentheses
      const telPattern = /^[\d\s\-()]+$/;
      this.isTelNoValid = telPattern.test(this.listAddr[i].strTelNo);
    },
    validateEmail(i) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailValid = emailPattern.test(this.listAddr[i].strEmail);
    },
    emailIsValid() {
      let regEx =
        /^(?!.*@)((^[^\.])[a-z0-9\.!#$%&'*+\-\/=?^_`{|}~"]*)*([^\.]$)/;
      return regEx.test(this.addr.strEmail);
    },
    showMessage() {
      this.enterPressed = true;
      setTimeout(() => {
        this.enterPressed = false;
      }, 3000);
    },
    showMessage2() {
      this.enterPressed2 = true;
      setTimeout(() => {
        this.enterPressed2 = false;
      }, 3000);
    },
    extractUniqueId(url) {
      const parts = url.split("/");
      return parts[parts.length - 1];
    },
    onView(url) {
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:9090";
      window.open(
        `${baseUrl}api/v1/custview/Cust/${url.strFileName}`,
        "_blank"
      );
    },
    async checkAndCompressListService(mode, input) {
      if (mode == "Cust") {
        if (this.listData.strFile != null) {
          this.listData.strFile.forEach((file, fileindex) => {
            if (file.size > 1048576 && file.type.startsWith("image/")) {
              let filename = file.name;
              let title =
                "The file " +
                filename +
                " is larger than 1 MB. Do you want to compress it?";
              this.$bvModal
                .msgBoxConfirm(title, {
                  title: "Compress Image?",
                  size: "m",
                  modalClass: "modal-success",
                  okVariant: "success",
                  okTitle: "Compress",
                  cancelTitle: "Cancel",
                  cancelVariant: "outline-warning",
                  hideHeaderClose: false,
                  //centered: true,
                })
                .then((value) => {
                  if (value) {
                    this.compressImage(mode, 1, index, fileindex);
                  } else {
                    this.listData.strFile = null;
                  }
                });
            }
          });
        }
      }
      if (mode == "Addr") {
        this.listAddr.forEach((file, fileindex) => {
          if (file.strFile != null) {
            if (file.size > 1048576 && file.type.startsWith("image/")) {
              let filename = file.name;
              let title =
                "The file " +
                filename +
                " is larger than 1 MB. Do you want to compress it?";
              this.$bvModal
                .msgBoxConfirm(title, {
                  title: "Compress Image?",
                  size: "m",
                  modalClass: "modal-success",
                  okVariant: "success",
                  okTitle: "Compress",
                  cancelTitle: "Cancel",
                  cancelVariant: "outline-warning",
                  hideHeaderClose: false,
                  //centered: true,
                })
                .then((value) => {
                  if (value) {
                    this.compressImage(mode, 1, index, fileindex);
                  } else {
                    file.strFile = null;
                  }
                });
            }
          }
        });
      }
    },
    tbuildFile(blob, name) {
      return new File([blob], name);
    },
    ttoBlob(imgUrl) {
      let blob = base64toblob(imgUrl.split(",")[1], "image/jpeg");
      let url = window.URL.createObjectURL(blob);
      return url;
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      var byteString = atob(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to an ArrayBuffer
      var arrayBuffer = new ArrayBuffer(byteString.length);
      var _ia = new Uint8Array(arrayBuffer);
      for (var i = 0; i < byteString.length; i++) {
        _ia[i] = byteString.charCodeAt(i);
      }
      var dataView = new DataView(arrayBuffer);
      var blob = new Blob([dataView], { type: mimeString });
      return blob;
    },
    compressImage(mode, input, index, fileindex) {
      let file;
      if (mode == "Cust") {
        file = this.listData.strFile[fileindex];
      }
      if (mode == "Addr") {
        file = this.listAddr[index].strFile[fileindex];
      }

      let imageData = null;
      let context = null;
      let maxWidth = 2400;
      let maxHeigt = 2400;
      let width = maxWidth;
      let height = maxHeigt;
      let vm = this;

      let reader = new FileReader();
      let name = file.name;

      let img = new Image();
      var canvas = document.createElement("canvas");
      reader.onload = function (e) {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

      img.onload = function () {
        // Draw
        context = canvas.getContext("2d");
        context.drawImage(img, 0, 0);

        if (img.width > maxWidth || img.height > maxHeigt) {
          width = maxWidth;
          height = maxHeigt;

          if (img.width > maxWidth) {
            width = maxWidth;
            var ration = maxWidth / img.width;
            height = Math.round(img.height * ration);
          }

          if (img.height > maxHeigt) {
            height = maxHeigt;
            var ration = maxHeigt / img.height;
            width = Math.round(img.width * ration);
          }
        } else {
          width = img.width;
          height = img.height;
        }
        canvas.width = width;
        canvas.height = height;

        context.drawImage(img, 0, 0, width, height);

        var objToPass = {};

        // Quality Of Image
        let quality = 100 / 100;
        imageData = canvas.toDataURL("image/jpeg", quality);
        imageData.replace("data:image/jpeg;base64,", "");
        let tblobToFile = vm.ttoBlob(imageData);
        let blobToFile = vm.dataURItoBlob(imageData);

        //console.log("imageData", imageData);
        //console.log(tblobToFile);
        //console.log(blobToFile);

        for (let qty = 100; blobToFile.size > 1048576 && qty > 0; ) {
          qty = qty - 10;
          quality = qty / 100;
          imageData = canvas.toDataURL("image/jpeg", quality);
          imageData.replace("data:image/jpeg;base64,", "");
          tblobToFile = vm.ttoBlob(imageData);
          blobToFile = vm.dataURItoBlob(imageData);
        }

        /* objToPass = {
          canvas: canvas,
          name: name,
          size: blobToFile.size,
          readsize: blobToFile.size / 1000,
          type: "image/jpeg",
          compressed: {
            blob: tblobToFile,
            base64: imageData,
            name: name,
            size: blobToFile.size,
            file: vm.tbuildFile(imageData, name),
          },
        }; */

        if (mode == "Cust") {
          vm.listData.strFile[fileindex] = vm.tbuildFile(imageData, name);
        }
        if (mode == "Addr") {
          vm.listAddr[index].strFile[fileindex] = vm.tbuildFile(
            imageData,
            name
          );
        }
      };
    },
    onChangeVal(inputid, mode) {
      if (inputid != "" && inputid != null) {
        if (mode == "type") {
          let currType = this.TypeOptions.find((t) => t.intDsId === inputid);
          this.listData.strType = currType.strDsDesc;
        }
        if (mode == "mainInd") {
          let currMain = this.MainOptions.find((t) => t.intDsId === inputid);
          this.listData.strIndusMainDesc = currMain.strDsDesc;
        }
        if (mode == "subInd") {
          let currSub = this.MainOptions.find((t) => t.intDsId === inputid);
          this.listData.strIndusSubDesc = currSub.strDsDesc;
        }
        if (mode == "source") {
          let currss = this.TestOptions.find((t) => t.intDsId === inputid);
          this.listData.strSource = currss.strDsDesc;
        }
        if (mode == "leadstage") {
          let currlead = this.leadstage.find((t) => t.intDsId === inputid);
          this.listData.strLead = currlead.strDsDesc;
        }
      }
    },
    onChangeAddr(index, inputid, mode) {
      if (inputid != "" && inputid != null) {
        if (mode == "country") {
          let currcountry = this.CountryOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strCountry = currcountry.strDsDesc;
        }
        if (mode == "province") {
          let currprovince = this.provinceOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strProvince = currprovince.strDsDesc;
          this.listAddr[index].intDistrictId = "";
          this.listAddr[index].strDistrict = "";
          this.listAddr[index].intSubDistrictId = "";
          this.listAddr[index].strSubDistrict = "";
          this.listAddr[index].intPostcodeId = "";
          this.listAddr[index].strPostcode = "";
        }
        if (mode == "district") {
          let currdistrict = this.districtOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strDistrict = currdistrict.strDsDesc;
          this.listAddr[index].intSubDistrictId = "";
          this.listAddr[index].strSubDistrict = "";
          this.listAddr[index].intPostcodeId = "";
          this.listAddr[index].strPostcode = "";
        }
        if (mode == "subdistrict") {
          let currsubdistrict = this.subdistrictOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strSubDistrict = currsubdistrict.strDsDesc;
        }
        if (mode == "postcode") {
          let currpostcode = this.postcodeOptions.find(
            (t) => t.intDsId === inputid
          );
          this.listAddr[index].strPostcode = currpostcode.strDsDesc;
        }
      }
    },
    onAddSubFreight() {
      var obj = {
        action: "",
        intCustomerId: -1,
        strContactName: "",
        strNickName: "",
        strTelNo: "",
        strEmail: "",
        strDepartment: "",
        strPosition: "",
      };
      this.listDetails.push(obj);
    },
    removeSubFreight(index) {
      this.listDetails.splice(index, 1);
    },
    onAddAddr() {
      var obj = {
        intCustomerId: -1,
        strAddrName: "",
        strAddrDesc: "",
        strTelNo: "",
        strEmail: "",
        strLink: "",
        strLocationMark: "",
        intProvinceId: "",
        strProvince: "",
        intDistrictId: "",
        strDistrict: "",
        intSubDistrictId: "",
        strSubDistrict: "",
        intPostcodeId: "",
        strPostcode: "",
        strRemark: "",
        strFile: null,
      };
      this.listAddr.push(obj);
    },
    removeAddr(index) {
      this.listAddr.splice(index, 1);
    },
    onSubmit(inputstatus) {
      let lang = localStorage.getItem("language");

      let ifcomp = true;
      let errorsmsg = "";

      this.$refs.headerForm.validate().then((success) => {
        if (success) {
          if (this.listDetails.length > 0) {
            this.listDetails.forEach((data, index) => {
              errorsmsg = "";
              let ifcompdefault = true;
              if (data.strContactName == "" || data.strContactName == null) {
                ifcomp = false;
                ifcompdefault = false;
                if (lang == "th_TH") {
                  errorsmsg =
                    errorsmsg +
                    " ข้อมูลผู้ติดต่อ รายการที่ " +
                    (index + 1) +
                    " - กรุณาเลือก ";
                } else {
                  errorsmsg =
                    errorsmsg +
                    " Contact Details No. " +
                    (index + 1) +
                    " - Please Select ";
                }
                errorsmsg = errorsmsg + " Contact Name , ";
              }

              if (errorsmsg != "") {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "กรอกข้อมูลให้ครบถ้วน",
                      icon: "AlertCircleIcon",
                      variant: "danger",
                      text: " Customer Register : " + errorsmsg,
                    },
                  },
                  {
                    position: "top-center",
                    timeout: 10000,
                  }
                );
              }
            });
          }
          if (!ifcomp) {
            return;
          }

          if (this.listAddr.length > 0) {
            this.listAddr.forEach((addr, addrindex) => {
              errorsmsg = "";
              let ifcompdefault = true;
              if (addr.strAddrName == "" || addr.strAddrName == null) {
                ifcomp = false;
                ifcompdefault = false;
                if (lang == "th_TH") {
                  errorsmsg =
                    errorsmsg +
                    " ข้อมูลบริษัท รายการที่ " +
                    (addrindex + 1) +
                    " - กรุณาเลือก ";
                } else {
                  errorsmsg =
                    errorsmsg +
                    " Customer Details No. " +
                    (addrindex + 1) +
                    " - Please Select ";
                }
                errorsmsg = errorsmsg + " Address Name , ";
              }
              if (addr.strAddrDesc == "" || addr.strAddrDesc == null) {
                ifcomp = false;
                if (ifcompdefault) {
                  ifcompdefault = false;
                  if (lang == "th_TH") {
                    errorsmsg =
                      errorsmsg +
                      " ข้อมูลบริษัท รายการที่ " +
                      (addrindex + 1) +
                      " - กรุณาเลือก ";
                  } else {
                    errorsmsg =
                      errorsmsg +
                      " Customer Details No. " +
                      (addrindex + 1) +
                      " - Please Select ";
                  }
                  errorsmsg = errorsmsg + " Address Detail , ";
                }
              }
              if (addr.strTelNo == "" || addr.strTelNo == null) {
                ifcomp = false;
                if (ifcompdefault) {
                  ifcompdefault = false;
                  if (lang == "th_TH") {
                    errorsmsg =
                      errorsmsg +
                      " ข้อมูลบริษัท รายการที่ " +
                      (addrindex + 1) +
                      " - กรุณาเลือก ";
                  } else {
                    errorsmsg =
                      errorsmsg +
                      " Customer Details No. " +
                      (addrindex + 1) +
                      " - Please Select ";
                  }
                  errorsmsg = errorsmsg + " Tel No. , ";
                }
              }
              // if (addr.strEmail == "" || addr.strEmail == null) {
              //   ifcomp = false;
              //   if (ifcompdefault) {
              //     ifcompdefault = false;
              //     if (lang == "th_TH") {
              //       errorsmsg =
              //         errorsmsg +
              //         " ข้อมูลบริษัท รายการที่ " +
              //         (addrindex + 1) +
              //         " - กรุณาเลือก ";
              //     } else {
              //       errorsmsg =
              //         errorsmsg +
              //         " Customer Details No. " +
              //         (addrindex + 1) +
              //         " - Please Select ";
              //     }
              //     errorsmsg = errorsmsg + " Email , ";
              //   }
              // }
              if (addr.intProvinceId == "" || addr.intProvinceId == null) {
                ifcomp = false;
                if (ifcompdefault) {
                  ifcompdefault = false;
                  if (lang == "th_TH") {
                    errorsmsg =
                      errorsmsg +
                      " ข้อมูลบริษัท รายการที่ " +
                      (addrindex + 1) +
                      " - กรุณาเลือก ";
                  } else {
                    errorsmsg =
                      errorsmsg +
                      " Customer Details No. " +
                      (addrindex + 1) +
                      " - Please Select ";
                  }
                  errorsmsg = errorsmsg + " Province , ";
                }
              }
              if (addr.intDistrictId == "" || addr.intDistrictId == null) {
                ifcomp = false;
                if (ifcompdefault) {
                  ifcompdefault = false;
                  if (lang == "th_TH") {
                    errorsmsg =
                      errorsmsg +
                      " ข้อมูลบริษัท รายการที่ " +
                      (addrindex + 1) +
                      " - กรุณาเลือก ";
                  } else {
                    errorsmsg =
                      errorsmsg +
                      " Customer Details No. " +
                      (addrindex + 1) +
                      " - Please Select ";
                  }
                  errorsmsg = errorsmsg + " District , ";
                }
              }
              if (
                addr.intSubDistrictId == "" ||
                addr.intSubDistrictId == null
              ) {
                ifcomp = false;
                if (ifcompdefault) {
                  ifcompdefault = false;
                  if (lang == "th_TH") {
                    errorsmsg =
                      errorsmsg +
                      " ข้อมูลบริษัท รายการที่ " +
                      (addrindex + 1) +
                      " - กรุณาเลือก ";
                  } else {
                    errorsmsg =
                      errorsmsg +
                      " Customer Details No. " +
                      (addrindex + 1) +
                      " - Please Select ";
                  }
                  errorsmsg = errorsmsg + " Sub-District , ";
                }
              }
              if (addr.intPostcodeId == "" || addr.intPostcodeId == null) {
                ifcomp = false;
                if (ifcompdefault) {
                  ifcompdefault = false;
                  if (lang == "th_TH") {
                    errorsmsg =
                      errorsmsg +
                      " ข้อมูลบริษัท รายการที่ " +
                      (addrindex + 1) +
                      " - กรุณาเลือก ";
                  } else {
                    errorsmsg =
                      errorsmsg +
                      " Customer Details No. " +
                      (addrindex + 1) +
                      " - Please Select ";
                  }
                  errorsmsg = errorsmsg + " Post code , ";
                }
              }

              if (errorsmsg != "") {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "กรอกข้อมูลให้ครบถ้วน",
                      icon: "AlertCircleIcon",
                      variant: "danger",
                      text: " Customer Details : " + errorsmsg,
                    },
                  },
                  {
                    position: "top-center",
                    timeout: 10000,
                  }
                );
              }
            });
          }
          if (!ifcomp) {
            return;
          }

          //ifcomp
          if (ifcomp) {
            this.busy = false;
            this.processing = false;
            //this.busy = true;
            this.strInputStatus = inputstatus;
            this.strStatusShow = "Confirm " + inputstatus;
            let b1 = inputstatus;
            let b2 = "Cancel";

            if (lang == "th_TH") {
              b1 = "ยืนยัน";
              b2 = "ยกเลิก";
              if (inputstatus == "Submit") {
                this.strStatusShow = "ยืนยันการบันทึกข้อมูล";
              } else {
                this.strStatusShow = "ยืนยันการบันทึกร่าง";
              }
            }

            this.$bvModal
              .msgBoxConfirm(this.strStatusShow, {
                title: this.strStatusShow,
                size: "sm",
                modalClass: "modal-success",
                okVariant: "success",
                okTitle: b1,
                cancelTitle: b2,
                cancelVariant: "outline-warning",
                hideHeaderClose: false,
                //centered: true,
              })
              .then((value) => {
                if (value) {
                  this.onSave();
                }
              });
          }
        } else {
          let message = "";
          if (
            this.listData.strCustomerName == null ||
            this.listData.strCustomerName == ""
          ) {
            if (lang == "th_TH") {
              message = message + "- ชื่อบริษัท ,";
            } else {
              message = message + "- Company Name ,";
            }
          }
          if (
            this.listData.intTypeId == null ||
            this.listData.intTypeId == ""
          ) {
            if (lang == "th_TH") {
              message = message + " ประเภทนิติบุคคล ";
            } else {
              message = message + " Type ";
            }
          }
          if (this.listData.strTaxId == null || this.listData.strTaxId == "") {
            if (lang == "th_TH") {
              message = message + " เลขผู้เสียภาษี ,";
            } else {
              message = message + " Tax Id ,";
            }
          }
          if (
            this.listData.intRegCapital == null ||
            this.listData.intRegCapital == "" ||
            this.listData.intRegCapital <= 0
          ) {
            if (lang == "th_TH") {
              message = message + " ทุนจดทะเบียน ,";
            } else {
              message = message + " Register Group ,";
            }
          }
          if (
            this.listData.intIndusMainId == null ||
            this.listData.intIndusMainId == ""
          ) {
            // if (lang == "th_TH") {
            //   message = message + " ประเภทอุตสาหกรรมหลัก,";
            // } else {
            //   message = message + " Main industry ,";
            // }
            this.listData.intIndusMainId = -1;
          }
          if (
            this.listData.intIndusSubId == null ||
            this.listData.intIndusSubId == ""
          ) {
            this.listData.intIndusSubId = -1;
          }
          if (
            this.listData.intSourceId == null ||
            this.listData.intSourceId == ""
          ) {
            this.listData.intSourceId = -1;
          }
          if (
            this.listData.intLeadId == null ||
            this.listData.intLeadId == ""
          ) {
            // if (lang == "th_TH") {
            //   message = message + " Lead Stage ,";
            // } else {
            //   message = message + " Lead Stage ,";
            // }
            this.listData.intLeadId = -1;
          }
          if (
            this.listData.intCustomerTierId == null ||
            this.listData.intCustomerTierId == ""
          ) {
            this.listData.intCustomerTierId = -1;
          }

          let titlemsg = "Please Fill in below details ";
          let alertmsg = "Please Select ";
          if (lang == "th_TH") {
            alertmsg = "กรุณาเลือก";
            titlemsg = "กรอกข้อมูลให้ครบถ้วน ";
          }
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: titlemsg,
                icon: "AlertCircleIcon",
                variant: "danger",
                text: alertmsg + message,
              },
            },
            {
              position: "top-center",
              timeout: 10000,
            }
          );
        }
      });
    },
    onSave() {
      let inputstatus = this.strInputStatus;
      let lang = localStorage.getItem("language");

      this.busy = true;
      this.processing = true;

      if (this.listData.freight_flag) {
        this.listData.strFreightFlag = "Y";
      }
      if (this.listData.broker_flag) {
        this.listData.strBrokerFlag = "Y";
      }
      if (this.listData.ra_flag) {
        this.listData.strRAFlag = "Y";
      }
      if (this.listData.legal_flag) {
        this.listData.strLegalFlag = "Y";
      }

      let fvalue = 0;
      fvalue = this.onchangeStringtoDouble(this.listData.intRegCapital);
      this.listData.intRegCapital = fvalue;
      fvalue = 0;

      fvalue = this.onchangeStringtoDouble(this.listData.intEstCost);
      this.listData.intEstCost = fvalue;
      fvalue = 0;

      // header file
      let confirm_file = [];
      let confirm_file_raw = [];
      let startcountfile = 0;
      if (this.listData.strFile != null) {
        this.listData.strFile.forEach((file, fileindex) => {
          ////console.log(file);
          ////console.log(file.name);
          let ffname = "Cust" + "//" + file.name;
          let type = file.name.split(".");
          ////console.log(file.size);
          ////console.log(type[1]);
          let intDId = -1;
          if (file.intDetailId != null) {
            intDId = file.intDetailId;
          }
          let fileobj = {
            intDetailId: intDId,
            intCustomerId: this.listData.intCustomerId,
            intItemId: fileindex,
            intAllItemId: startcountfile,
            intFileIndex: 1,
            strFileFromService: "Cust",
            strFreightFileName: file.name,
            strFileName: file.name,
            filesize: file.size,
            strFileType: file.type,
          };
          confirm_file.push(fileobj);
          confirm_file_raw.push(file);
          startcountfile++;
        });
      }

      let confirm_contact_list = [];
      if (this.listDetails.length > 0) {
        this.listDetails.forEach((data, index) => {
          confirm_contact_list.push(data);
        });
      }

      let confirm_account_list = [];
      // if (this.ownerrows.length > 0) {
      //   this.ownerrows.forEach((acc, accindex) => {
      //     if (acc.intUserId != "" && acc.intUserId != null) {
      //       let aage = this.UserOptions.find(
      //         (t) => t.intDsId === acc.intUserId
      //       );
      //       if (aage) {
      //         acc.strUsername = aage.strDsDesc;
      //       }
      //     }
      //     if (acc.intSubUserId != "" && acc.intSubUserId != null) {
      //       let suba = this.UserOptions.find(
      //         (t) => t.intDsId === acc.intSubUserId
      //       );
      //       if (suba) {
      //         acc.strSubUsername = suba.strDsDesc;
      //       }
      //     }
      //     confirm_account_list.push(acc);
      //   });
      // }

      let confirm_addr_list = [];
      let confirm_addr_file = [];
      let confirm_addr_file_raw = [];
      let addrstartcountfile = 0;
      if (this.listAddr.length > 0) {
        this.listAddr.forEach((addr, addrindex) => {
          let startcountAddr = -2;
          if (addr.intDetailId == "" || addr.intDetailId == null) {
            addr.intDetailId = startcountAddr;
            startcountAddr--;
          }
          confirm_addr_list.push(addr);
          // file
          if (addr.strFile != null) {
            addr.strFile.forEach((file, fileindex) => {
              let ffname = "Addr//" + file.name;
              let type = file.name.split(".");
              let intDId = -1;
              if (file.intDetailId != null) {
                intDId = file.intDetailId;
              }
              let fileobj = {
                intDetailId: intDId,
                intCustomerId: this.listData.intCustomerId,
                intAddrId: startcountAddr,
                intItemId: fileindex,
                intAllItemId: addrstartcountfile,
                intFileIndex: 1,
                strFileFromService: "Addr",
                strFreightFileName: file.name,
                strFileName: file.name,
                filesize: file.size,
                strFileType: file.type,
              };
              confirm_addr_file.push(fileobj);
              confirm_addr_file_raw.push(file);
              addrstartcountfile++;
            });
          }
        });
      }

      this.isSaving = true;
      var dataSave = {
        headerGrid: this.listData,
        intCustomerId: this.listData.intCustomerId,
        status: this.strInputStatus,
        contactList: confirm_contact_list,
        accountList: confirm_account_list,
        addressList: confirm_addr_list,
        headerFile: confirm_file,
        addrFile: confirm_addr_file,
      };
      console.log("dataSave", dataSave);

      let formData = new FormData();
      confirm_file_raw.forEach((x) => {
        formData.append("files", x);
      });
      confirm_addr_file_raw.forEach((x) => {
        formData.append("files2", x);
      });
      formData.append("strJson", JSON.stringify(dataSave));

      CustService.saveCustomer(formData)
        .then((response) => {
          if (response.data == "ชื่อบริษัทซ้ำ") {
            this.busy = false;
            this.processing = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: response.data,
                },
              },
              {
                position: "top-center",
              }
            );
          } else {
            this.$router.replace({ name: "customer-search" }).then(() => {
              let compmsg = "Save Completed";
              if (lang == "th_TH") {
                compmsg = "บันทึกสำเร็จ";
              }
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: compmsg,
                    icon: "CheckIcon",
                    variant: "success",
                    text: response.data.message,
                  },
                },
                {
                  position: "top-center",
                }
              );
            });
          }
        })
        .catch((error) => {
          this.busy = false;
          this.processing = false;
          this.isSaving = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onBack() {
      this.$router.push({ name: "customer-search" });
    },
    onchangeStringtoDouble(input) {
      let value;
      if (typeof input === "string") {
        value = Number.parseFloat(input.replaceAll(",", ""));
      } else if (typeof input === "string" && (input == "" || input == null)) {
        value = 0;
      } else {
        value = input;
      }
      return value;
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
